import qs from 'query-string'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Divider } from 'antd'
import PdfAnnotationModal from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/PreviewPanel/PreviewItem/PdfAnnotationModal'
import { DONT_SHOW_ANNOTATION_INTRODUCTION } from '@Builder/QuoteDetailPage/logic'
import {
    DFM_NEEDS_FICTIV_REVIEW,
    DFM_NO_ACTION_REQUIRED,
    ImDfmStateType,
} from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'
import {
    PDF_VIEWER_QUERY_PARAM,
    VIEWER_QUERY_PARAM,
} from '@Admin/AdminQuotingPage/constants'

import Button from '~/core/Button'
import Text from '~/core/Text'
import { getUserIdentity } from '~/redux-modules/identity'
import { getLocalStorageItem } from '~/lib/localStorage'

const BUTTON_STYLE = {
    fontWeight: 500,
    marginBottom: '8px',
}
const ANNOTATE_SEARCH = 'annotate'
const PLACEMENT = 'im-dfm-slide-action-panel'
const VIEWER_MODE_SEARCH_PARAM = 'mode'

interface AnnotateSlideButtonPropsType {
    status: ImDfmStateType
}

const AnnotateSlideButton = (props: AnnotateSlideButtonPropsType) => {
    const { status } = props

    const navigate = useNavigate()
    const location = useLocation()
    const identity = useSelector(getUserIdentity)

    const [showPdfAnnotationModal, setShowPdfAnnotationModal] =
        useState<boolean>(false)

    const onBeginAnnotating = () => {
        const currentQueryParams = qs.parse(location.search)
        const newQueryParams = {
            ...currentQueryParams,
        }

        newQueryParams[VIEWER_MODE_SEARCH_PARAM] = ANNOTATE_SEARCH
        newQueryParams[VIEWER_QUERY_PARAM] = PDF_VIEWER_QUERY_PARAM

        navigate(
            {
                search: qs.stringify(newQueryParams),
            },
            { replace: true },
        )
    }

    const onClickAnnotateSlide = () => {
        const isCheckboxTicked = getLocalStorageItem(
            `${DONT_SHOW_ANNOTATION_INTRODUCTION}-${identity.id}`,
        )

        if (!isCheckboxTicked) {
            setShowPdfAnnotationModal(true)
        } else {
            onBeginAnnotating()
        }
    }

    const onClosePdfAnnotationModal = () => {
        setShowPdfAnnotationModal(false)

        onBeginAnnotating()
    }

    const showEditAnnotationBtn = status === DFM_NEEDS_FICTIV_REVIEW
    const showAnnotationSlideBtn = !showEditAnnotationBtn
    const noActionRequiredStatus = status === DFM_NO_ACTION_REQUIRED

    return (
        <>
            {showPdfAnnotationModal && (
                <PdfAnnotationModal
                    onClose={onClosePdfAnnotationModal}
                    type="im-dfm"
                    userId={identity.id}
                />
            )}
            {showEditAnnotationBtn && (
                <Button
                    data-test-target="im-dfm-modal-edit-annotation"
                    name="edit-annotation"
                    onClick={onClickAnnotateSlide}
                    placement={PLACEMENT}
                    style={BUTTON_STYLE}
                >
                    Edit Annotation
                </Button>
            )}
            {showAnnotationSlideBtn && (
                <>
                    {!noActionRequiredStatus && (
                        <Divider
                            style={{ alignItems: 'start', margin: '8px 0' }}
                        >
                            <Text fontSize="12px" color="blackAlpha65">
                                OR
                            </Text>
                        </Divider>
                    )}
                    <Button
                        data-test-target="im-dfm-modal-annotate-slide"
                        name="annotate-slide"
                        onClick={onClickAnnotateSlide}
                        placement={PLACEMENT}
                        style={BUTTON_STYLE}
                    >
                        Annotate slide
                    </Button>
                    <Text
                        color="blackAlpha45"
                        fontSize="11px"
                        style={{ textAlign: 'center' }}
                    >
                        All annotations will be reviewed by a Fictiv engineer
                    </Text>
                </>
            )}
        </>
    )
}

export default AnnotateSlideButton
